export default "__VITE_ASSET__8ikfWndw__"